import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("himt_admin_token") ||
                localStorage.getItem("himt_student_token") ||
                localStorage.getItem("token"); // fallback to main app token
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const studentApi = (token) => {
  const inst = axios.create({ baseURL: API });
  inst.defaults.headers.common.Authorization = `Bearer ${token}`;
  return inst;
};

export const adminApi = () => {
  const token = localStorage.getItem("himt_admin_token") || localStorage.getItem("token");
  const inst = axios.create({ baseURL: API });
  if (token) inst.defaults.headers.common.Authorization = `Bearer ${token}`;
  return inst;
};

export const fileUrl = (path, token) =>
  `${API}/files/${path}?auth=${encodeURIComponent(token)}`;
